module.exports = __webpack_public_path__ + "static/media/eel_bowl.63fb72ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/dish_image/eel_bowl.jpg
// module id = 157
// module chunks = 0